import {
  WebSocketSessionzi1ianvyj32u as WebSocketSession,
  close1my1iwn6t9rqe as close,
  closeExceptionally34577q18g9dav as closeExceptionally,
  send3oe3simbzresd as send,
} from './WebSocketSession.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance1onda8f6dyvl as Companion_getInstance,
  from3gpkuvfyl3bft as from,
  ChannelOverflow_SUSPEND_getInstance2mhr6ng5la4d as ChannelOverflow_SUSPEND_getInstance,
  ChannelConfigftdbykui5s0q as ChannelConfig,
} from './WebSocketChannelsConfig.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import {
  BytePacketBuilder2biodf4wxvlba as BytePacketBuilder,
  writeFully359t6q8kam2g5 as writeFully,
  buildjygoh729rhy8 as build,
  get_size2imoy2jq11jxl as get_size,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstancelqb1l3z6ws7q as Companion_getInstance_0,
  Ping3nta6l7sdq1r9 as Ping,
  Pong3m3cas9hmc9ec as Pong,
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from './Frame.web.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import {
  readReason2qq1b0s02pdpy as readReason,
  NonDisposableHandle_instance103hbd30a1suv as NonDisposableHandle_instance,
} from './FrameCommon.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import {
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  ChannelResult2y4k69ac6y3du as ChannelResult,
  _ChannelResult___get_isSuccess__impl__odq1z9363u9zgwpgg09 as _ChannelResult___get_isSuccess__impl__odq1z9,
  Factory_getInstance1n4mqriubejsu as Factory_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_CLOSED_ABNORMALLY_getInstance18g5hbbmrws6x as Codes_CLOSED_ABNORMALLY_getInstance,
  Codes_NORMAL_getInstance21orcjign6rr6 as Codes_NORMAL_getInstance,
  Codes_TOO_BIG_getInstance3opvqzqi8vcjj as Codes_TOO_BIG_getInstance,
} from './CloseReason.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ChannelIOException2i3t76lsrbgox as ChannelIOException } from '../../../../ktor-ktor-utils/io/ktor/util/cio/Channels.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { Dispatchers_getInstancewbokwrm9sosb as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CoroutineStart_UNDISPATCHED_getInstanceldihd7d5m0an as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  pingerd16zvjbf6m9o as pinger,
  ponger270tezdl2mu68 as ponger,
} from './PingPong.mjs';
import { FrameTooBigException1rgdafsgu31sm as FrameTooBigException } from './FrameTooBigException.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instance17dpgmdbeabno as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { get_OUTGOING_CHANNEL_CAPACITY2ancx42jsldm9 as get_OUTGOING_CHANNEL_CAPACITY } from './Utils.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return LOGGER;
}
var LOGGER;
function get_IncomingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return IncomingProcessorCoroutineName;
}
var IncomingProcessorCoroutineName;
function get_OutgoingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return OutgoingProcessorCoroutineName;
}
var OutgoingProcessorCoroutineName;
function get_NORMAL_CLOSE() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return NORMAL_CLOSE;
}
var NORMAL_CLOSE;
var OUTGOING_CHANNEL_CONFIG;
var DefaultWebSocketSessionClass;
function DefaultWebSocketSession() {
  if (DefaultWebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DefaultWebSocketSessionClass = $;
  }
  return DefaultWebSocketSessionClass;
}
function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis, channelsConfig) {
  pingIntervalMillis = pingIntervalMillis === VOID ? 0n : pingIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? 15000n : timeoutMillis;
  channelsConfig = channelsConfig === VOID ? Companion_getInstance().v59_1 : channelsConfig;
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  // Inline function 'kotlin.require' call
  if (!!isInterface(session, DefaultWebSocketSession())) {
    var message = 'Cannot wrap other DefaultWebSocketSession';
    throw IllegalArgumentException().s2(toString(message));
  }
  return new (DefaultWebSocketSessionImpl())(session, pingIntervalMillis, timeoutMillis, channelsConfig.w59_1, channelsConfig.x59_1);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.y59_1.lx($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.z59_1.lx($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.a5a_1.e5a_1.px();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var firstFrame = null;
  var frameBody = null;
  var closeFramePresented = false;
  try {
    // Inline function 'kotlinx.coroutines.channels.consumeEach' call
    var tmp0 = $this.o5a_1.b5a_1.s59();
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.channels.consume' call
      var cause = null;
      try {
        var _iterator__ex2g4s = tmp0.u1();
        $l$loop: while (true) {
          var tmp = _iterator__ex2g4s.q1a($completion);
          if (tmp === get_COROUTINE_SUSPENDED())
            tmp = yield tmp;
          if (!tmp) {
            break $l$loop;
          }
          var e = _iterator__ex2g4s.w1();
          $l$block_0: {
            // Inline function 'io.ktor.util.logging.trace' call
            var this_0 = get_LOGGER();
            if (get_isTraceEnabled(this_0)) {
              var tmp$ret$0 = 'WebSocketSession(' + toString($this$launch) + ') receiving frame ' + e.toString();
              this_0.f4s(tmp$ret$0);
            }
            if (e instanceof Close()) {
              if (!$this.o5a_1.t59().x1a()) {
                var tmp_0 = $this.o5a_1.t59();
                var tmp1_elvis_lhs = readReason(e);
                var tmp_1 = tmp_0.e1b(Close().g5b(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), $completion);
                if (tmp_1 === get_COROUTINE_SUSPENDED())
                  tmp_1 = yield tmp_1;
              }
              closeFramePresented = true;
              return Unit_instance;
            } else {
              if (e instanceof Pong()) {
                var tmp2_safe_receiver = $this.o5a_1.c5a_1.kotlinx$atomicfu$value;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  var tmp_2 = tmp2_safe_receiver.e1b(e, $completion);
                  if (tmp_2 === get_COROUTINE_SUSPENDED())
                    tmp_2 = yield tmp_2;
                }
              } else {
                if (e instanceof Ping()) {
                  var tmp_3 = $this.p5a_1.e1b(e, $completion);
                  if (tmp_3 === get_COROUTINE_SUSPENDED())
                    tmp_3 = yield tmp_3;
                } else {
                  var tmp_4 = checkMaxFrameSize($this.o5a_1, frameBody, e, $completion);
                  if (tmp_4 === get_COROUTINE_SUSPENDED())
                    tmp_4 = yield tmp_4;
                  if (!e.q5a_1) {
                    if (firstFrame == null) {
                      firstFrame = e;
                    }
                    if (frameBody == null) {
                      frameBody = BytePacketBuilder();
                    }
                    writeFully(frameBody, e.s5a_1);
                    break $l$block_0;
                  }
                  if (firstFrame == null) {
                    var tmp_5 = $this.o5a_1.g5a_1.e1b(processIncomingExtensions($this.o5a_1, e), $completion);
                    if (tmp_5 === get_COROUTINE_SUSPENDED())
                      tmp_5 = yield tmp_5;
                    break $l$block_0;
                  }
                  writeFully(ensureNotNull(frameBody), e.s5a_1);
                  var defragmented = Companion_getInstance_0().y5a(true, firstFrame.r5a_1, readByteArray(build(frameBody)), firstFrame.u5a_1, firstFrame.v5a_1, firstFrame.w5a_1);
                  firstFrame = null;
                  var tmp_6 = $this.o5a_1.g5a_1.e1b(processIncomingExtensions($this.o5a_1, defragmented), $completion);
                  if (tmp_6 === get_COROUTINE_SUSPENDED())
                    tmp_6 = yield tmp_6;
                }
              }
            }
          }
        }
        break $l$block_1;
      } catch ($p) {
        if ($p instanceof Error) {
          var e_0 = $p;
          cause = e_0;
          throw e_0;
        } else {
          throw $p;
        }
      }
      finally {
        cancelConsumed(tmp0, cause);
      }
    }
  } catch ($p) {
    if ($p instanceof ClosedSendChannelException()) {
      var _unused_var__etf5q3 = $p;
    } else {
      if ($p instanceof Error) {
        var cause_0 = $p;
        $this.p5a_1.r1b();
        $this.o5a_1.g5a_1.p1b(cause_0);
      } else {
        throw $p;
      }
    }
  }
  finally {
    $this.p5a_1.r1b();
    var tmp0_safe_receiver = frameBody;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.q6();
    }
    $this.o5a_1.g5a_1.r1b();
    if (!closeFramePresented) {
      var tmp_7 = close($this.o5a_1, CloseReason().m59(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  try {
    var tmp = outgoingProcessorLoop($this.h5b_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof ClosedSendChannelException()) {
      var _unused_var__etf5q3 = $p;
    } else {
      if ($p instanceof ClosedReceiveChannelException()) {
        var _unused_var__etf5q3_0 = $p;
      } else {
        if ($p instanceof CancellationException()) {
          var _unused_var__etf5q3_1 = $p;
          var tmp_0 = sendCloseSequence$default($this.h5b_1, CloseReason().m59(Codes_NORMAL_getInstance(), ''), VOID, $completion);
          if (tmp_0 === get_COROUTINE_SUSPENDED())
            tmp_0 = yield tmp_0;
        } else {
          if ($p instanceof ChannelIOException()) {
            var _unused_var__etf5q3_2 = $p;
          } else {
            if ($p instanceof Error) {
              var cause = $p;
              $this.h5b_1.h5a_1.ox(CancellationException().p('Failed to send frame', cause));
              var tmp_1 = closeExceptionally($this.h5b_1.b5a_1, cause, $completion);
              if (tmp_1 === get_COROUTINE_SUSPENDED())
                tmp_1 = yield tmp_1;
              return Unit_instance;
            } else {
              throw $p;
            }
          }
        }
      }
    }
  }
  finally {
    $this.h5b_1.h5a_1.t1b();
    var tmp_2 = close($this.h5b_1.b5a_1, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  var tmp = sendCloseSequence($this.i5b_1, it, IOException().h4h('Ping timeout'), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_flush__owbk1c($this, $completion) {
  var tmp = $this.b5a_1.k4i($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function runIncomingProcessor($this, ponger) {
  var tmp = get_IncomingProcessorCoroutineName().om(Dispatchers_getInstance().k13_1);
  return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger));
}
function runOutgoingProcessor($this) {
  var tmp = get_OutgoingProcessorCoroutineName().om(Dispatchers_getInstance().k13_1);
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this));
}
function *_generator_outgoingProcessorLoop__h1ph7a($this, $completion) {
  var _iterator__ex2g4s = $this.h5a_1.u1();
  $l$loop_0: while (true) {
    var tmp = _iterator__ex2g4s.q1a($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      break $l$loop_0;
    }
    var frame = _iterator__ex2g4s.w1();
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$0 = 'Sending ' + frame.toString() + ' from session ' + toString($this);
      this_0.f4s(tmp$ret$0);
    }
    var tmp_0;
    if (frame instanceof Close()) {
      var tmp_1 = sendCloseSequence$default($this, readReason(frame), VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      break $l$loop_0;
    } else {
      var tmp_2;
      if (frame instanceof Text()) {
        tmp_2 = true;
      } else {
        tmp_2 = frame instanceof Binary();
      }
      if (tmp_2) {
        tmp_0 = processOutgoingExtensions($this, frame);
      } else {
        tmp_0 = frame;
      }
    }
    var processedFrame = tmp_0;
    var tmp_3 = $this.b5a_1.t59().e1b(processedFrame, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function outgoingProcessorLoop($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_outgoingProcessorLoop__h1ph7a.bind(VOID, $this), $completion);
}
function *_generator_sendCloseSequence__8ec8rh($this, reason, exception, $completion) {
  if (!tryClose($this))
    return Unit_instance;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$0 = 'Sending Close Sequence for session ' + toString($this) + ' with reason ' + toString_0(reason) + ' and exception ' + toString_0(exception);
    this_0.f4s(tmp$ret$0);
  }
  $this.e5a_1.w12();
  var reasonToSend = reason == null ? CloseReason().m59(Codes_NORMAL_getInstance(), '') : reason;
  try {
    runOrCancelPinger($this);
    if (!(reasonToSend.j59_1 === Codes_CLOSED_ABNORMALLY_getInstance().f59_1)) {
      var tmp = $this.b5a_1.t59().e1b(Close().g5b(reasonToSend), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }finally {
    $this.d5a_1.u12(reasonToSend);
    if (!(exception == null)) {
      $this.h5a_1.p1b(exception);
      $this.g5a_1.p1b(exception);
    }
  }
  return Unit_instance;
}
function sendCloseSequence($this, reason, exception, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sendCloseSequence__8ec8rh.bind(VOID, $this, reason, exception), $completion);
}
function sendCloseSequence$default($this, reason, exception, $completion, $super) {
  exception = exception === VOID ? null : exception;
  return sendCloseSequence($this, reason, exception, $completion);
}
function tryClose($this) {
  return $this.i5a_1.atomicfu$compareAndSet(false, true);
}
function runOrCancelPinger($this) {
  var interval = $this.l5a_1;
  var tmp;
  if ($this.i5a_1.kotlinx$atomicfu$value) {
    tmp = null;
  } else if (interval > 0n) {
    var tmp_0 = $this.b5a_1.t59();
    var tmp_1 = $this.m5a_1;
    tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this));
  } else {
    tmp = null;
  }
  var newPinger = tmp;
  var tmp0_safe_receiver = $this.c5a_1.atomicfu$getAndSet(newPinger);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.r1b();
  var tmp2_safe_receiver = newPinger == null ? null : new (ChannelResult())(newPinger.f1b(Companion_getInstance_1().j5b_1));
  if (tmp2_safe_receiver == null)
    null;
  else
    _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.d1b_1);
  if ($this.i5a_1.kotlinx$atomicfu$value && !(newPinger == null)) {
    runOrCancelPinger($this);
  }
}
function *_generator_checkMaxFrameSize__26jxa6($this, packet, frame, $completion) {
  var tmp = frame.s5a_1.length;
  var tmp1_elvis_lhs = packet == null ? null : get_size(packet);
  var size = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  if (fromInt(size) > $this.r59()) {
    if (packet == null)
      null;
    else {
      packet.q6();
    }
    var tmp_0 = close($this, CloseReason().m59(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + size + '. Max size is ' + $this.r59().toString()), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    throw FrameTooBigException().n5b(fromInt(size));
  }
  return Unit_instance;
}
function checkMaxFrameSize($this, packet, frame, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_checkMaxFrameSize__26jxa6.bind(VOID, $this, packet, frame), $completion);
}
function processIncomingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.o5b().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    var current = accumulator;
    accumulator = element.p5b(current);
  }
  return accumulator;
}
function processOutgoingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.o5b().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    var current = accumulator;
    accumulator = element.q5b(current);
  }
  return accumulator;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.j5b_1 = Pong().y5b(new Int8Array(0), NonDisposableHandle_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DefaultWebSocketSessionImpl$start$slambdaClass;
function DefaultWebSocketSessionImpl$start$slambda() {
  if (DefaultWebSocketSessionImpl$start$slambdaClass === VOID) {
    class $ {
      constructor($incomingJob, $outgoingJob, this$0) {
        this.y59_1 = $incomingJob;
        this.z59_1 = $outgoingJob;
        this.a5a_1 = this$0;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$start$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$start$slambdaClass;
}
function DefaultWebSocketSessionImpl$start$slambda_0($incomingJob, $outgoingJob, this$0) {
  var i = new (DefaultWebSocketSessionImpl$start$slambda())($incomingJob, $outgoingJob, this$0);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass;
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda() {
  if (DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $ponger) {
        this.o5a_1 = this$0;
        this.p5a_1 = $ponger;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass;
}
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger) {
  var i = new (DefaultWebSocketSessionImpl$runIncomingProcessor$slambda())(this$0, $ponger);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass;
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda() {
  if (DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.h5b_1 = this$0;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass;
}
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0) {
  var i = new (DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda())(this$0);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass;
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda() {
  if (DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.i5b_1 = this$0;
      }
      z5b(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.z5b(p1 instanceof CloseReason() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass;
}
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0) {
  var i = new (DefaultWebSocketSessionImpl$runOrCancelPinger$slambda())(this$0);
  var l = (it, $completion) => i.z5b(it, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImplClass;
function DefaultWebSocketSessionImpl() {
  if (DefaultWebSocketSessionImplClass === VOID) {
    class $ {
      constructor(raw, pingIntervalMillis, timeoutMillis, incomingFramesConfig, outgoingFramesConfig) {
        Companion_getInstance_1();
        this.b5a_1 = raw;
        this.c5a_1 = atomic$ref$1(null);
        this.d5a_1 = CompletableDeferred();
        this.e5a_1 = Job();
        this.f5a_1 = this.b5a_1.ew().mm(Key_instance).om(this.e5a_1).om(new (CoroutineName())('ws-default'));
        this.g5a_1 = from(Factory_getInstance(), incomingFramesConfig);
        this.h5a_1 = from(Factory_getInstance(), outgoingFramesConfig);
        this.i5a_1 = atomic$boolean$1(false);
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.j5a_1 = ArrayList().u2();
        this.k5a_1 = atomic$boolean$1(false);
        this.l5a_1 = pingIntervalMillis;
        this.m5a_1 = timeoutMillis;
        this.n5a_1 = this.d5a_1;
      }
      ew() {
        return this.f5a_1;
      }
      s59() {
        return this.g5a_1;
      }
      t59() {
        return this.h5a_1;
      }
      o5b() {
        return this.j5a_1;
      }
      q59(value) {
        this.b5a_1.q59(value);
      }
      r59() {
        return this.b5a_1.r59();
      }
      o59() {
        return this.n5a_1;
      }
      p59(negotiatedExtensions) {
        if (!this.k5a_1.atomicfu$compareAndSet(false, true)) {
          // Inline function 'kotlin.error' call
          var message = 'WebSocket session ' + toString(this) + ' is already started.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'io.ktor.util.logging.trace' call
        var this_0 = get_LOGGER();
        if (get_isTraceEnabled(this_0)) {
          var tmp$ret$0 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
          this_0.f4s(tmp$ret$0);
        }
        this.j5a_1.z2(negotiatedExtensions);
        runOrCancelPinger(this);
        var incomingJob = runIncomingProcessor(this, ponger(this, this.t59()));
        var outgoingJob = runOutgoingProcessor(this);
        launch(this, VOID, VOID, DefaultWebSocketSessionImpl$start$slambda_0(incomingJob, outgoingJob, this));
      }
      k4i($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_flush__owbk1c.bind(VOID, this), $completion);
      }
    }
    protoOf($).u59 = send;
    initMetadataForClass($, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession(), WebSocketSession()], [1, 0, 2]);
    DefaultWebSocketSessionImplClass = $;
  }
  return DefaultWebSocketSessionImplClass;
}
var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
function _init_properties_DefaultWebSocketSession_kt__469s0y() {
  if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
    properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
    LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
    IncomingProcessorCoroutineName = new (CoroutineName())('ws-incoming-processor');
    OutgoingProcessorCoroutineName = new (CoroutineName())('ws-outgoing-processor');
    NORMAL_CLOSE = CloseReason().m59(Codes_NORMAL_getInstance(), 'OK');
    var tmp0_safe_receiver = get_OUTGOING_CHANNEL_CAPACITY();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (ChannelConfig())(tmp0_safe_receiver, ChannelOverflow_SUSPEND_getInstance());
    }
    OUTGOING_CHANNEL_CONFIG = tmp;
  }
}
//region block: exports
export {
  DefaultWebSocketSession_0 as DefaultWebSocketSessionmehckluw85jl,
  DefaultWebSocketSession as DefaultWebSocketSession3h8506yqzs5fx,
  get_LOGGER as get_LOGGER1pnacb4n2g1eb,
};
//endregion

//# sourceMappingURL=DefaultWebSocketSession.mjs.map
